import { useMemo, type ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from './client';

// Wraps the app in a configured Apollo Client. The client is created once per
// provider mount; auth tokens are resolved per-request inside the links, so the
// same client instance works across sign-in/sign-out transitions.
export function ApolloAppProvider({ children }: { children: ReactNode }): ReactNode {
  const client = useMemo(() => createApolloClient(), []);
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
